import { KeyboardEvent, useCallback } from "react";

export const useEnterCallback = (callback: Function) => {
  const onKeydown = useCallback(
    (event: KeyboardEvent<HTMLDivElement | HTMLTextAreaElement | HTMLInputElement>) => {
      if (event.code === "Enter") {
        callback();
        event.preventDefault();
      }
    },
    [callback],
  );

  return onKeydown;
};
